var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconView98396D04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44898",
    "data-name": "Group 44898",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2221",
    "data-name": "Ellipse 2221",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54622",
    "data-name": "Group 54622",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23468",
    "data-name": "Rectangle 23468",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81976",
    "data-name": "Path 81976",
    d: "M-23,14a9.8,9.8,0,0,1,9.016-6A9.735,9.735,0,0,1-5,14",
    transform: "translate(26.162)",
    fill: "none",
    stroke: "#454545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4423",
    "data-name": "Ellipse 4423",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "#454545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView98396D04);
export default __webpack_public_path__ + "static/media/icon-view.98396d04.f4d9448ffa9ce3069ebf2efa457d3d36.svg";
export { ForwardRef as ReactComponent };